// Client lib imports
const { localStorage } = require('client/lib/storage')

const cachesByLocalStorageKey = new Map()

class TooltipsDismissedCache {
  /**
   * @param {string} localStorageKey
   * @returns {TooltipsDismissedCache}
   * @public
   */
  static forLocalStorageKey(localStorageKey) {
    if (cachesByLocalStorageKey.has(localStorageKey)) {
      return cachesByLocalStorageKey.get(localStorageKey)
    }
    const cache = new TooltipsDismissedCache(localStorageKey)
    cachesByLocalStorageKey.set(localStorageKey, cache)
    return cache
  }

  /**
   * @param {string} localStorageKey
   * @constructor
   * @private
   */
  constructor(localStorageKey) {
    this.localStorageKey = localStorageKey
    const valueStr = localStorage.getItem(this.localStorageKey)
    this.dismissedKeys = new Set(JSON.parse(valueStr || '[]'))
  }

  /**
   * @param {string} tooltipKey
   * @returns {boolean}
   * @public
   */
  get(tooltipKey) {
    return this.dismissedKeys.has(tooltipKey)
  }

  /**
   * @param {string} tooltipKey
   * @returns {void}
   * @public
   */
  set(tooltipKey) {
    this.dismissedKeys.add(tooltipKey)
    const valueStr = JSON.stringify([ ...this.dismissedKeys ])
    localStorage.setItem(this.localStorageKey, valueStr)
  }
}

module.exports = TooltipsDismissedCache
